import { render, staticRenderFns } from "./FundingTab.vue?vue&type=template&id=7b90f0ef"
import script from "./FundingTab.vue?vue&type=script&lang=js"
export * from "./FundingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports